import HorizontalRule from "../components/HorizontalRule"
import TextAreaLarge from "../components/TextAreaLarge"
import ThumbScroller from "../components/ThumbScroller"

const PortfolioScroller = (props) => {
    const { textArea, horizontalRule, thumbScroller } = props;

    return(
        <>
            <TextAreaLarge {...textArea} />
            <HorizontalRule props={horizontalRule} />
            <ThumbScroller {...thumbScroller} />
        </>
    )
}

export default PortfolioScroller;